import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ReportsService } from "../reports.service";
import { SportService } from "src/app/sports/sport.service";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";

@Component({
    selector: "app-public-sport-category-fixture",
    templateUrl: "./public-sport-category-fixture.component.html",
    styleUrls: ["./public-sport-category-fixture.component.scss"],
})
export class PublicSportCategoryFixtureComponent implements OnInit {
    public categoryFixtureData: any = null;
    public groupResult: any = null;
    public isLoaded: any = false;
    public isMiniMarathon: any = false;

    constructor(
        private spinner: NgxSpinnerService,
        private reportsService: ReportsService,
        private sportService: SportService,
        private activetedRoute: ActivatedRoute,
        private location: Location
    ) {
        this.spinner.show();
        document.querySelector("body").classList.add("public-content");
        this.activetedRoute.params.subscribe((params) => {
            if (params === null || params === undefined) {
                setTimeout(() => {
                    this.spinner.hide();
                }, 500);

                return false;
            }

            this.sportService
                .getPublicCateporySports(params.id)
                .subscribe((res) => {
                    this.categoryFixtureData = res.result;
                    this.groupResult = res.group_result;
                    this.isMiniMarathon = params.id === "275";

                    setTimeout(() => {
                        this.spinner.hide();
                        this.isLoaded = true;
                    }, 500);
                });
        });
    }

    ngOnInit() {}

    goBack(): void {
        this.location.back();
    }
}
